export function number(number, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(number, decimal);
}

export function vnd(money, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(money, decimal, ',') + " đ";
}

export function vnd2(money, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(money, decimal);
}

export function gam(gam, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(gam, decimal) + " g";
}

export function cm(cm, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(cm, decimal) + " cm";
}

export function percent(percent, decimal) {
  decimal = typeof decimal === "undefined" ? 0 : decimal;
  return formatNumber(percent, decimal) + " %";
}

export function currency(value, decimal) {
  if (value) {
    let number = +value.replace(/[^\d.]/g, "");
    number = isNaN(number) ? 0 : number;
    decimal = typeof decimal === "undefined" ? 0 : decimal;
    return formatNumber(number, decimal);
  }
}

function formatNumber(number, places, thousand, decimal) {
  number = number || 0;
  places = !isNaN((places = Math.abs(places))) ? places : 2;
  // thousand = thousand || ",";
  thousand = thousand || ".";
  decimal = decimal || ".";
  let negative = number < 0 ? "-" : "";
  let i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + "";
  let j = i.length;
  j = j > 3 ? j % 3 : 0;

  return (
    negative +
    (j ? i.substr(0, j) + thousand : "") +
    i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : "")
  );
}
export function vnTimeAgo(time) {
  var date_now = new Date();
  var date = new Date(time);

  // var minutes = date.getMinutes();
  // var hour = date.getHours();
  var year = date.getFullYear();
  var month = date.getMonth();
  var day = date.getDate();
  var day_now = date_now.getDate();

  if(year == 0 || month == 0 || day == 0){
    var DateString = date.toLocaleDateString();
    const arrdate = DateString.split('/');
    year = arrdate[2];
    month = arrdate[0];
    day = arrdate[1];
  }

  time = Number(date)
  const between = (Date.now() - time) / 1000
  if (between < 60) {
    return 'vừa xong'
  }
  else if (between < 86400) {
    if(day_now == day)
      return formatAMPM(date)
    else
      return formatAMPM(date) + '  ' + formatDay(date)
  }
  else if (between < 86400 * 7) {
    return formatAMPM(date) + '  ' + formatDay(date)
  }
  else {
    // Viết lại hàm hiển thị giờ
    let  d = new Date(time);
    let day = d.getDate();
    let hour = d.getHours();
    let minute = d.getMinutes();
    let month = d.getMonth() + 1;
    if (hour < 10) {
      hour = '0' + hour;
    }
    if (minute < 10) {
      minute = '0' + minute;
    }
    if (day < 10) {
      day = '0' + day;
    }
    if (month < 10) {
      month = '0' + month;
    }
    let datestring = hour + ":" + minute + " " + day + "/" + month + "/" + d.getFullYear();
    return datestring;

    // return String(hour).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + ' ' + String(day).padStart(2, '0') + '/' + String(month).padStart(2, '0') + '/' + String(year)
  }
}
function formatDay(date){
  var current_day = date.getDay();
  var day_name = '';
  switch (current_day) {
    case 0:
      day_name = "CN";
      break;
    case 1:
      day_name = "T2";
      break;
    case 2:
      day_name = "T3";
      break;
    case 3:
      day_name = "T4";
      break;
    case 4:
      day_name = "T5";
      break;
    case 5:
      day_name = "T6";
      break;
    case 6:
      day_name = "T7";
  }

  return day_name
}
function formatAMPM(date) {
  var hours = date.getHours();
  var minutes = date.getMinutes();
  var ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12;
  minutes = minutes < 10 ? '0'+minutes : minutes;
  var strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
}
